import * as pbi from "powerbi-client";
import authService from "@services/auth";
import configClientes from "@configs/configs.js";

export default [
  {
    path: "/",
    name: "home",
    component: () => lazyLoadView(import("@views/Home"))
  },
  {
    path: "/workspace",
    name: "workSpace",
    component: () => lazyLoadView(import("@views/Workspace"))
  },
  {
    path: "/Login",
    name: "login",
    component: () => configClientes.telaLogin(),
    meta: {
      beforeResolve(to, from, next) {
        var authenticated = authService.isAuthenticated();

        // refreshtoken
        if (authenticated === false) {
          const isAuthenticated = () => {
            authService
              .refreshToken()
              .then(() => authService.isAuthenticated());
          };
          authenticated = isAuthenticated();
        }

        if (authenticated === true) {
          next({ name: "home" });
        } else {
          next();
        }
      }
    }
  },
  {
    path: "/CadastrarSenha",
    name: "cadastrar-senha",
    component: () => import("@views/CadastrarSenha")
  },
  {
    path: "/EsqueceuSenha",
    name: "esqueceu-senha",
    component: () => import("@views/EsqueceuSenha")
  },
  {
    path: "/Logout",
    name: "logout",
    meta: {
      beforeResolve() {
        authService.logout();
      }
    }
  },
  {
    path: "/Report/:ReportKey/:WorkSpaceKey",
    name: "Reports",
    props: { editable: false, pbi: pbi },
    component: () => lazyLoadView(import("@views/Report"))
  },
  {
    path: "/403",
    name: "403",
    component: require("@views/_403").default,
    props: true
  },
  {
    path: "/404",
    name: "404",
    component: require("@views/_404").default,
    props: true
  },
  {
    path: "*",
    redirect: "404"
  },
  {
    path: "/DePara",
    name: "depara",
    component: () => import("@views/DePara")
  },
  {
    path: "/permissoes",
    name: "permissoes",
    component: () => import("@views/Permissoes")
  },
  {
    path: "/grupo",
    name: "grupo",
    props: {
      name: "Grupo",
      table: "Grupo",
      fields: [{ name: "denominacao", description: "Nome" }]
    },
    component: () => import("@views/Grupo")
  },
  {
    path: "/grupo/Detalhes/:id",
    name: "grupo-detalhes",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/GrupoItem"))
  },
  {
    path: "/Dre",
    name: "dre",
    props: {
      name: "Dre",
      table: "Dre",
      fields: [{ name: "denominacao", description: "Nome" }]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/Dre/Novo",
    name: "dre-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/DreForm"))
  },
  {
    path: "/Dre/Detalhes/:id",
    name: "Dre-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/DreItens"))
  },
  {
    path: "/Dre/Edit/:id",
    name: "Dre-edit",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/DreForm"))
  },
  {
    path: "/ReportPro/:id",
    name: "Report-Pro",
    component: () => lazyLoadView(import("@views/ReportPro"))
  },
  {
    path: "/DreRateio",
    name: "DreRateio",
    component: () => import("@views/DreRateio")
  },
  {
    path: "/Usuarios",
    name: "Usuario",
    component: () => import("@views/Usuario")
  }
];

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    loading: require("@views/_loading").default,
    delay: 100,
    error: require("@views/_timeout").default,
    timeout: 10000
  });

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children);
    }
  });
}
